import styled, {keyframes} from "styled-components";
import {Anchor, Placement} from "./Anchor";
import React, {useState} from "react";

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const TooltipStyle = styled.div`
  padding: 8px 12px 12px;
  height: auto;
  background-color: rgba(44, 44, 44, 0.9);
  color: #ffffff;
  border-radius: 5px;
  font-size: 0.9em;
  min-width: 80px;
  max-width: 260px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  animation: ${fadeIn} 0.15s ease forwards;
`;

const Arrow = styled.div`
  background-color: rgba(44, 44, 44, 0.9);
  animation: ${fadeIn} 0.15s ease forwards;
`

export const Tooltip =
  ({
   children,
    my = "bottom center",
    at = "top center",
    margin,
    arrowGap
  }: { children: string, my?: Placement, at?: Placement, margin?: string, arrowGap?: number }) => {
  return (
    <Anchor.Popup arrowGap={arrowGap} my={my} at={at} margin={margin} arrowSize={10} withArrow={Arrow} arrowType='triangle'>
      <TooltipStyle>
        {children}
      </TooltipStyle>
    </Anchor.Popup>
  )
}

const TooltipTrigger = styled(
  ({className, children, tooltip}: { className?: string, children: React.ReactNode, $lineHeight?: number, tooltip: React.ReactNode }) => {
    const [isOpen,setIsOpen] = useState(false);
    const handleMouseEnter = () => {
      setIsOpen(true);
    }
    const handleMouseLeave = () => {
      setIsOpen(false)
    }
    return <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className={className}>
      {children}
      {isOpen && tooltip}
    </div>;
  }
)`
  position: relative;
  cursor: pointer;
  ${props => `
    line-height: ${props.$lineHeight || 0}px;
  `}
`;

Tooltip.Trigger = TooltipTrigger;